export class RangeNumber
{
  From?:number
  To?: number
}